import { Typography } from '@mui/material';
import Colors from 'js/constants/colors';

const ComboBoxInfoText = (props) => (
    <Typography
        variant="body2"
        sx={{
            color: Colors.BLACK_30_OPAQUE,
            marginBottom: '5px',
            ...props.sx,
        }}
    >
        Select an option or manually enter a value
    </Typography>
)

export default ComboBoxInfoText;
